import cookieControl from '../../../methods/cookieControl'

export default {
    name: 'added-to-cart-notification',
    data(){
        return {
            
        }
    },
    props: { 
        dataShoppingUrl: String,
        continueShoppingLabel : String,
        toBasketLabel : String,
        toBasketUrl : String 
    },
    computed:{
        getCartNotificationData() {
            return this.$store.state.main.addToCartHtmlString
        },
        displayCartNotification() {
            return this.$store.state.main.showCartNotification
        },
        previousPageCookie() {
            return cookieControl.getItem("shopfilter")
        },
        continueShoppingUrl() {
            return this.dataShoppingUrl;
        }  
    },
    methods: {
        closeNotification() {
            this.$store.commit("main/displayCartNotification", false)
        },
        continueShopping() {
            let cookie = cookieControl.getItem("shopfilter")
            if (!cookie || cookie === 'undefined') {
                cookieControl.removeItem('shopfilter', '/')
                cookie = null
            }
            const url = this.continueShoppingUrl

            window.location.href = cookie && url
                ? `${url}${cookie}`
                : url
                    ? url
                    : '/'
        }
    }
}

